// extracted by mini-css-extract-plugin
export default {"link":"Privacy_link__zAD6S","modalOverlay":"Privacy_modalOverlay__InrON","modalContent":"Privacy_modalContent__VpAsw","closeButton":"Privacy_closeButton__4JGrz"};